import { environment } from '../../../environments/environment';

const cleanBaseUrl = (url: string): string =>
  (url || '')
    .trim()
    .replace(/^['"]+|['"]+$/g, '')
    .replace(/\/+$/, '')
    .replace(/\/api$/, '');

const createBaseUrl = (url: string): string => {
  return `${cleanBaseUrl(url)}/api`;
};

/**
 * The dev proxy only exists when the app is served by `ng serve`.
 * If a development build is deployed to a real host, relative paths like

 */
const isLocalHost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

const useProxy = (environment as any).useDevProxy === true && isLocalHost;

const isUsa = (country?: string | null): boolean =>
  (country || '').trim().toUpperCase() === 'USA';

export const getSsoBaseUrl = (country?: string | null): string => {
  if (useProxy) {
    return isUsa(country) ? '/usa-api' : '/api';
  }

  if (isUsa(country)) {
    return createBaseUrl((environment as any).usabackedbaseurl);
  }

  return createBaseUrl(environment.backendBaseUrl);
};

const DEFAULT_BASE_URL = useProxy
  ? '/api'
  : createBaseUrl(environment.backendBaseUrl);

export const getSsoRoutes = (country?: string | null) => {
  const BASE_URL = getSsoBaseUrl(country);

  return {
    // Geo lookup runs before a country is known, so it always uses the
    // default (India) backend. Switch to BASE_URL if the USA backend
    // also serves this endpoint.
    GET_COUNTRY_BY_LOCATION: `${DEFAULT_BASE_URL}/geo/getCountryByLocation`,

    LOGIN: `${BASE_URL}/auth/login`,
    VERIFY_OTP: `${BASE_URL}/auth/verifyOTP`,
    VERIFY_PASSWORD: `${BASE_URL}/auth/verifyPassword`,
    FORGOT_PASSWORD_OTP: `${BASE_URL}/auth/sendOtp/forgotPassword`,

    RECOVERY_SETUP: `${BASE_URL}/auth/recoverySetup`,
    RECOVERY_SETUP_VERIFY: `${BASE_URL}/auth/recoverySetupVerify`,
    COMPLETE_RECOVERY_SETUP: `${BASE_URL}/auth/completeRecoverySetup`,

    CONTINUE_UNTRUSTED: `${BASE_URL}/auth/continueUntrusted`,
    ADD_TRUSTED_DEVICE: `${BASE_URL}/auth/addTrustedDevice`,
    REVIEW_APPROVAL: `${BASE_URL}/auth/reviewApproval`,

    CHECK_DEVICE: `${BASE_URL}/auth/checkDevice`,
    LOGIN_BY_TRUSTED_DEVICE: `${BASE_URL}/auth/loginByTrustedDevice`,
    REVOKE_DEVICE: `${BASE_URL}/auth/revokeDevice`,

    AUTHORIZE_SESSION: `${BASE_URL}/auth/authorizeSession`,
    GET_PROFILE_DETAILS: `${BASE_URL}/auth/getProfileDetails`,
    LOGOUT: `${BASE_URL}/auth/logout`,
  };
};
